import { gql } from '@apollo/client';

export const READ_LEGAL_ADDRESS_STATUS = gql`
  query ReadLegalAddressStatus($input: LegalAddressStatusInput) {
    readLegalAddressStatus(input: $input) {
      error
      message
      status
    }
  }
`;
